
import {img1} from '../assets/images'

const KeyBenefitsData = [
    {
        Name: 'Revenue Planning',
        Description: 'Turn accurate demand forecasts into confident revenue projections. Anticipate future sales volumes so budgeting and financial planning are grounded in data, not guesswork.',
        Points: [
            'Predict sales volumes by product, store and period',
            'Build data-backed budgets and revenue targets',
            'Align finance and planning teams on one number',
        ],
        Image: img1,
    },
    {
        Name: 'Resource Allocation',
        Description: 'Put inventory, people and capital exactly where demand is heading. Allocate resources based on forecasted need instead of gut feel.',
        Points: [
            'Distribute stock to high-demand locations',
            'Right-size production and staffing to demand',
            'Cut waste from over- and under-allocation',
        ],
        Image: img1,
    },
    {
        Name: 'Cash Flow Management',
        Description: 'Smooth out cash flow by knowing what you will sell and when. Plan purchases and payments around real demand signals to protect liquidity.',
        Points: [
            'Time procurement to actual demand',
            'Avoid cash tied up in dead stock',
            'Forecast inflows for healthier liquidity',
        ],
        Image: img1,
    },
    {
        Name: 'Marketing Strategy',
        Description: 'Time campaigns and promotions to demand peaks. Focus spend on the products, regions and seasons most likely to convert.',
        Points: [
            'Target high-potential SKUs and regions',
            'Plan promotions around demand spikes',
            'Measure lift against the baseline forecast',
        ],
        Image: img1,
    },
    {
        Name: 'Risk Mitigation',
        Description: 'Spot demand volatility early and act before it hurts. Built-in validation and scenario views reduce forecasting risk across the board.',
        Points: [
            'Catch anomalies and data gaps early',
            'Stress-test plans with what-if scenarios',
            'Reduce stockout and overstock exposure',
        ],
        Image: img1,
    },
    {
        Name: 'Setting Realistic Targets',
        Description: 'Set goals your team can actually hit. Ground targets in statistical forecasts and track them with clear accuracy metrics.',
        Points: [
            'Base targets on model-driven baselines',
            'Track performance with RMSE, MAPE and MAE',
            'Refine continuously as new data lands',
        ],
        Image: img1,
    },
]

export { KeyBenefitsData }
